<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style"; 
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";

import Table from "../../../components/Table";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "Gestión de empresas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,

    Table,
  },
  data() {
    return {
      title: "Gestión de empresas",

      
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <Table />
      </div>
    </div>
  </Layout>
</template>
